import Myapplicationview from "../../../jsx/components/Dashboard/MyApplications/myapplicationview";

const MyApplicationViewWrapper = () => {
  return <Myapplicationview />;
};

export default constore(MyApplicationViewWrapper);
